<template>
  <div class="container">
    <hr class="space space-xs">
    <hr class="space space-xs">
    <h1 class="h2 mb-3">Царь горы 👑</h1>
    <p>На странице "Царь горы" вы можете увидеть рейтинг пользователей, основанный на их достижениях в походах. В таблице на странице отображаются пользователи, отсортированные по их достижениям.</p>
    <hr class="space space-xs">
    <table class="table">
      <thead>
        <tr>
          <th>Рейтинг</th>
          <th>Имя</th>
          <th>Фото</th>
          <th>Пройдено</th>
          <th>Набор высоты</th>
          <th>Время</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, index) in leaderboard" :key="user.id || user.userId">
          <td>{{ index + 1 }}</td>
          <td>
            <span v-if="index == 0">👑</span>
            <strong v-if="user.userId == 'o7b92fHYgtTbTallR5EBcMnMB9J2'">ЗАБУГОРЩИКИ</strong>
            <span v-else-if="user.userName">{{ user.userName }}</span>
            <span v-else>{{ user.firstName }} {{ user.lastName }}</span>
          </td>
          <td>
            <router-link :to="{ name: 'public-profile', params: { id: user.id || user.userId } }">
              <img v-if="user.userId == 'o7b92fHYgtTbTallR5EBcMnMB9J2'" class="img-fluid rounded-circle mr-2" width="30" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/logo_xs.jpg" alt="">
              <img v-else-if="user.photoUrl" class="img-fluid rounded-circle mr-2" width="30" :src="user.photoUrl" alt="">
              <img v-else-if="user.userName" class="img-fluid rounded-circle mr-2" width="30" :src="`https://ui-avatars.com/api/?name=${user.userName.charAt(0)}&size=30&rounded=true`" alt="">
              <img v-else-if="user.firstName" class="img-fluid rounded-circle mr-2" width="30" :src="`https://ui-avatars.com/api/?name=${user.firstName.charAt(0)}&size=30&rounded=true`" alt="">
            </router-link>
          </td>
          <td>{{ formatDistance(user.totalDistance) }}</td>
          <td>{{ formatElevation(user.totalElevation) }}</td>
          <td>{{ formatDuration(user.totalDuration) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Leaderboard',
  computed: {
    ...mapState({
      currentUser: state => state.auth.user,
      users: state => state.auth.users,
      usersStats: state => state.hikes.usersStats
    }),
    leaderboard () {
      const mergedUsers = this.users.map(user => ({
        ...user,
        totalDistance: '-',
        totalElevation: '-',
        totalDuration: '-'
      }))
      return [...this.usersStats, ...mergedUsers]
    }
  },
  created () {
    this.getLeaderboard()
  },
  methods: {
    formatDistance (distance) {
      return distance === '-' ? distance : `${distance.toFixed(2)} км`
    },
    formatElevation (elevation) {
      return elevation === '-' ? elevation : `${elevation} м`
    },
    formatDuration (duration) {
      return duration === '-' ? duration : `${duration} часов`
    },
    getLeaderboard () {
      this.$store.dispatch('GET_USER')
      this.$store.dispatch('GET_ALL_USERS')
      this.$store.dispatch('GET_HIKE_STATS')
    }
  }
}
</script>